Vue.component('v-form', {
  methods: {
    validate: function () {
      var $form = $(this.$el).find('form')
      var hasError = false
      $form.find('input:not([name="czn"]), textarea').map((index, el)=> {
        if (!$(el).val()) {
          hasError = true
          $(el).closest('.form__input').addClass('form__input--error')
        }
      })
      return !hasError
    },
    removeErrorState: function () {
      var $form = $(this.$el).find('form')
      $form.find('.form__input--error').removeClass('form__input--error')
    },
    send: function (e) {
      e.preventDefault()
      var $form = $(this.$el).find('form')
      var $formId = $form.attr('id')

      var $data = {
        formId: $formId,
        params: $form.serialize(),
        act: $form.attr('act')
      }
      var self = this
      $.ajax({
        url: '/ajax.php',
        data: $data,
        type: 'post',
        beforeSend: function() {
          if (!self.validate()) return false
          $(e.target).attr('disabled', true)
        },
        success: function success(data) {
          if (data.state) {
            self.$actions.setFormSuccess(true)
          } else {
            alert(data.msgtxt)
          }
          $(e.target).attr('disabled', false)
          $form.find('input, textarea').val('')
        },
        error: function error() {
          $(e.target).attr('disabled', false)
          return alert(
            'При отправке произошла непредвиденная ошибка! Повторите, пожалуйста, попытку позже.'
          )
        }
      })
    }
  },
})
